import React, { useEffect, useRef } from "react";

export type HubSpotFormProps = {
  portalId?: string;
  formId: string;
  formContainerId: string;
};

export const HubSpotForm: React.FC<HubSpotFormProps> = ({
  portalId,
  formId,
  formContainerId,
}) => {
  const ref = useRef(false);

  useEffect(() => {
    const loadForm = () => {
      if (!ref.current && window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: `#${formContainerId}`,
        });
        ref.current = true;
      }
    };

    loadForm();
    const token = setInterval(loadForm, 1000);

    return () => {
      clearInterval(token);
    };
  }, [portalId, formId, formContainerId]);

  if (!portalId) {
    return null;
  }

  return (
    <div>
      <div id={formContainerId} data-testid="hubspot-form-container"></div>
    </div>
  );
};
